module.exports = {
  text: `Они выглядят как пауки, но их колония ведет себя как муравейник, подчиняющийся королеве, а её королева — Ллос. А Ллос — та ещё вспыльчивая и жестокая штучка`,
  author: `Эльминстер`,
}
